export default __webpack_public_path__ + "static/media/me8.6943666a.jpg";